import $ from 'jquery';
import React from "react";
import PropTypes from 'prop-types';

import * as Misc from "./../misc";

export default class ScrollButtonView extends React.Component {
  static propTypes = {
    direction: PropTypes.string.isRequired,
    elementToScroll: PropTypes.string.isRequired
  };

  handleClick = (e) => {
    Misc.ignoreDefault(e);
    const el = $(this.props.elementToScroll);
    const dx = (this.props.direction === 'left' || this.props.direction === 'up') ? -1 : 1;
    const that = this;
    el.each(function () {
      if (that.props.direction === 'left' || that.props.direction === 'right') {
        $(this).animate({
          'scrollLeft': this.scrollLeft + $(this).width() / 2 * dx
        });
      } else {
        $(this).animate({
          'scrollTop': this.scrollTop + 60 * dx
        });
      }
    });
  };

  render() {
    let className = '';
    switch (this.props.direction) {
      case 'left':
        className = 'scrolling-buttons-left';
        break;
      case 'right':
        className = 'scrolling-buttons-right';
        break;
      case 'up':
        className = 'scrolling-buttons-up';
        break;
      case 'down':
        className = 'scrolling-buttons-down';
        break;
    }
    return (
      <div className={className} onClick={this.handleClick}/>
    );
  }
};




// WEBPACK FOOTER //
// ./src/components/scrollButtonView.js